import type { UseQueryOptions } from '@tanstack/react-query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type * as API from '@trinity/chat/api/interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { AxiosResponse } from 'axios';

type Data = API.Projects.FetchMultiSurveyResponses.Response;
type QueryKey = [string, Props];
type Props = {
  limit?: number;
  projectId: number;
  questionId?: number;
};

export function useFetchAllProjectSurveyResponses<TData = Data>(props: Props, options: { enabled?: boolean; } = {}) {
  const api = useChatApiClient();

  return useQuery({
    queryKey: keyUseFetchAllSurveyResponses(props),
    queryFn: ({ queryKey }) => {
      const params = queryKey[1] as Props;
      return api.projects.fetchAllSurveyResponses(params);
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    ...options,
  });
}

function keyUseFetchAllSurveyResponses(props: Props) {
  return ['get:projects/surverys/all-responses', props];
}

export default useFetchAllProjectSurveyResponses;